import React, { useEffect, useState } from "react";
import Navbar from "../../../Component/Home/Navbar";
import img7 from "../../../Assets/home/img7.png";
import logo from "../../../Assets/footer/logo.svg";
import Fb from "../../../Assets/footer/Fb.svg";
import Insta from "../../../Assets/footer/Insta.svg";
import LinkedIn from "../../../Assets/footer/LinkedIn.svg";
import Youtube from "../../../Assets/footer/Youtube.svg";
import BlogImg1 from "../../../Assets/Blogs/BlogImg1.jpg";
import Blog2 from "../../../Assets/Blogs/Blog2.jpg";
import Blog3 from "../../../Assets/Blogs/Blog3.jpg";
import { useLocation } from "react-router-dom";

const blogCards = [
  {
    id: 1,
    title: "Proud Moment for BCV ClaimPro Assist Pvt. Ltd.",
    image:
      "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/Blogs/BlogImg1.jpg",
    content: (
      <>
        <p>
          We are delighted to announce that Mr. Bhavneesh Malik, the founder and
          managing director of BCV ClaimPro Assist Pvt. Ltd., has been honored
          with the prestigious "Leading Innovator in Logistics Solutions" award
          by the ET Business Awards, an initiative by The Times of India Group.
          This award is a recognition of Mr. Malik’s visionary leadership,
          commitment to innovation, and his continuous efforts to bring positive
          change in the logistics sector. Under his guidance, ClaimPro Assist
          has become a trusted name in accident logistics, insurance support,
          and vehicle recovery services across India.
        </p>
        <blockquote className="m-2 border-l-4 border-[#21A6E9] pl-2 italic text-[#444] bg-[#F0F8FF] py-2">
          "We are deeply honored by this recognition"
        </blockquote>
        <p>A heartfelt congratulations to the entire team!</p>
      </>
    ),
  },
  {
    id: 2,
    title:
      "Prestigious Recognition for ClaimPro Assist at Infotech Forum 2025.",
    image:
      "https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/Blogs/Blog3.jpg",
    content: (
      <>
        <p>
          We are delighted to share that our Chief Technology Officer, Mr. Mohan
          Shah, has been honoured with the prestigious “Eminent CIOs of India
          2025-2026” award by VAR India.
          <blockquote className="m-2 border-l-4 border-[#21A6E9] pl-2 italic text-[#444] bg-[#F0F8FF] py-2">
            The award was presented at the VAR India Infotech Forum 2025, held
            on 4th July 2025 at Hotel Hyatt Regency, New Delhi.
          </blockquote>
          This recognition is a testament to Mr. Shah’s visionary leadership,
          technological excellence, and his relentless pursuit of innovation in
          the tech-enabled Vehicle Support Management space. His contributions
          continue to shape the future of ClaimPro Assist and the broader
          industry. We congratulate Mr. Shah and his team on this well-deserved
          achievement and look forward to many more milestones together!
        </p>
      </> 
    ),
  },
];

export default function ReadBlog() {
  const location = useLocation();
  const { blogId } = location.state || {};
  const [modalData, setModalData] = useState(null);
  const blog = blogCards.find((b) => b.id === blogId);

  //   const relatedBlogMap = {
  //   1: [2, 3],
  //   2: [1, 3],
  //   3: [1, 2],
  // };

    useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };
    
    scrollToTop();
    
    const timeoutId = setTimeout(() => {
      scrollToTop();
    }, 100);
    
    return () => clearTimeout(timeoutId);
  }, []);

  const relatedBlogMap = {
    1: [2],
    2: [1],
  };

  const relatedBlogs = blogCards.filter((card) =>
    relatedBlogMap[blogId]?.includes(card.id)
  );

  if (!blog) {
    return (
      <div className="text-center text-red-500 mt-10 font-satoshi">
        Blog not found.
      </div>
    );
  }

  return (
    <div className="font-satoshi min-h-screen bg-white">
      <Navbar />

      <div className="md:px-[5%] px-[5%] ">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6  pt-[3%]">
          {blog.title}
        </h1>
        <div className="  font-satoshi space-y-6 text-left text-[17px] leading-7 text-[#222] pb-[2rem]">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">{blog.content}</div>
            <img
              src={blog.image}
              alt="Blog"
              className="w-full md:w-1/2 h-80 mb-6 rounded-md object-cover"
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#E5F6FF]  py-2 px-4 md:px-12 flex flex-col md:flex-row justify-between items-center md:items-start font-satoshi">
        {/* Left: Logo and Name */}
        <div className="flex items-center gap-2 mt-2 mb-1 md:mb-0 flex-nowrap">
          <img
            src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/logo.svg"
            alt="ClaimPro Assist Logo"
            className="h-12"
          />
          <p className=" font-satoshi text-[18px] leading-[32px] text-[#0A0119] mb-0 whitespace-nowrap">
            © 2025 BCV ClaimPro Assist Private Limited.
          </p>
        </div>

        {/* Right: Social Links */}
        <div className="text-right font-satoshi">
          <p className="text-[18px] mr-2 mb-1">Follow us on</p>
          <div className="flex gap-2 items-end">
            <a
              href="https://www.facebook.com/p/BVC-ClaimPro-Assist-61559865797607/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Fb.svg"
                alt="Facebook"
                className="h-6 w-6"
              />
            </a>
            <a
              href="https://www.instagram.com/bvc_claimpro_assist_official/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Insta.svg"
                alt="Instagram"
                className="h-6 w-6"
              />
            </a>
            <a
              href="https://in.linkedin.com/company/bvc-claim-pro-assist"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/LinkedIn.svg"
                alt="LinkedIn"
                className="h-6 w-6"
              />
            </a>
            <a
              href="https://www.youtube.com/watch?v=qmUlSNG5xKg"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/footer/Youtube.svg"
                alt="YouTube"
                className="h-6 w-6"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
